// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#173457" // brand blue
    },
    secondary: {
      main: "#fcdf68" // brand gold
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff"
    },
    text: {
      primary: "#000000",
      secondary: "rgba(0,0,0,0.7)"
    }
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
    h1: { fontWeight: 700, letterSpacing: "-0.5px" },
    h2: { fontWeight: 700, letterSpacing: "-0.5px" },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    body1: { lineHeight: 1.6 }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: "bold"
        },
        containedPrimary: {
          backgroundColor: "#173457",
          color: "#fff",
          "&:hover": { backgroundColor: "#0f2338" }
        },
        containedSecondary: {
          backgroundColor: "#fcdf68",
          color: "#173457",
          "&:hover": { backgroundColor: "#fbd04a" }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
        }
      }
    }
  }
});

export default theme;